// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2Pozx","overflowing":"ReadFullNote_overflowing__1hIBz"};